const API_CONFIG = {
  // API: 'http://drupal.docker.localhost/v1',
  // ADMIN_API: ' http://drupal.docker.localhost',
  API: 'https://api.nexum.boream.es/v1',
  ADMIN_API: 'https://api.nexum.boream.es',
  AUTH_ID_CLIENTE: 'cc1dc60f-0d88-46c9-80a3-464c82d1743a',
  AUTH_PASS_ID_CLIENTE: 'analista',
};
export default API_CONFIG;




// WEBPACK FOOTER //
// ./src/config.js